import React from "react";
import { Redirect, Route, useHistory } from "react-router-dom";

const PrivateRoute = ({ component: Component, roles, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      // console.log(roles, currentUser, roles.indexOf(currentUser.role) === -1);
      if (localStorage.getItem("authToken")) {
        // check if route is restricted by role
        if (roles && currentUser && roles.indexOf(currentUser.role) === -1) {
          // role not authorised so redirect to home page
          return <Redirect to={{ pathname: "/" }} />;
          // return history.go("/login");
        }
        return <Component {...props} />;
      } else return <Redirect to="/login" />;
    }}
  />
);

export default PrivateRoute;
